import styled from "styled-components";
import tw from "twin.macro";

// Styled Components
export const FilterOverlay = styled.div`
  ${tw`fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4`}
  backdrop-filter: blur(4px);
`;

export const FilterModal = styled.div`
  ${tw`bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-screen overflow-hidden flex flex-col`}
  max-height: 85vh;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
`;

export const FilterHeader = styled.div`
  ${tw`flex items-center justify-between p-6 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50`}
`;

export const FilterTitle = styled.div`
  ${tw`flex items-center gap-3`}
  
  h2 {
    ${tw`text-xl font-bold text-gray-900 m-0`}
  }
`;

export const FilterIcon = styled.div`
  ${tw`text-blue-600 p-2 bg-blue-100 rounded-lg`}
`;

export const ActiveFiltersBadge = styled.span`
  ${tw`bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-full px-3 py-1 text-xs font-bold min-w-6 text-center shadow-lg`}
`;

export const CloseButton = styled.button`
  ${tw`p-2 rounded-xl text-gray-400 hover:text-gray-600 hover:bg-white transition-all border-none bg-transparent cursor-pointer shadow-sm`}
  
  &:disabled {
    ${tw`opacity-50 cursor-not-allowed`}
  }
`;

export const FilterContent = styled.div`
  ${tw`flex-1 overflow-y-auto p-6 space-y-6`}
`;

export const FilterSection = styled.div`
  ${tw`bg-gray-50 rounded-xl p-5 border border-gray-100`}
`;

export const SectionHeader = styled.div`
  ${tw`flex items-center gap-3 mb-4`}
`;

export const SectionIcon = styled.div`
  ${tw`text-blue-600 p-2 bg-blue-100 rounded-lg`}
`;

export const SectionTitle = styled.h3`
  ${tw`text-lg font-semibold text-gray-800 m-0`}
`;

export const ModernDateModeSelector = styled.div`
  ${tw`flex bg-white rounded-lg p-1 border border-gray-200 mb-4`}
`;

export const DateModeButton = styled.button`
  ${tw`flex-1 flex items-center justify-center gap-2 py-2 px-4 rounded-md text-sm font-medium transition-all border-none cursor-pointer`}
  
  ${props => props.$active 
    ? tw`bg-blue-600 text-white shadow-sm` 
    : tw`bg-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50`
  }
`;

export const InputRow = styled.div`
  ${tw`grid grid-cols-1 md:grid-cols-2 gap-4`}
`;

export const ModernInputGroup = styled.div`
  ${tw`space-y-2`}
`;

export const InputLabel = styled.label`
  ${tw`block text-sm font-medium text-gray-700`}
`;

export const ModernInput = styled.input`
  ${tw`w-full px-4 py-3 border border-gray-300 rounded-lg text-sm transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
  
  ${props => props.$hasError && tw`border-red-500 focus:ring-red-500`}
  ${props => props.$hasPrefix && tw`pl-8`}
  
  &:disabled {
    ${tw`bg-gray-100 text-gray-500 cursor-not-allowed`}
  }
`;

export const ModernSelect = styled.select`
  ${tw`w-full px-4 py-3 border border-gray-300 rounded-lg text-sm transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer`}
  
  &:disabled {
    ${tw`bg-gray-100 text-gray-500 cursor-not-allowed`}
  }
`;

export const AmountInputWrapper = styled.div`
  ${tw`relative`}
  
  &::before {
    content: '$';
    ${tw`absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm pointer-events-none`}
  }
`;

export const CurrencyPrefix = styled.span`
  ${tw`absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm pointer-events-none`}
`;

export const ErrorMessage = styled.span`
  ${tw`text-red-500 text-xs mt-1 block`}
`;

export const FilterFooter = styled.div`
  ${tw`flex items-center justify-between p-6 border-t border-gray-100 bg-gray-50`}
`;

export const ActionButtons = styled.div`
  ${tw`flex items-center gap-3`}
`;

export const ClearButton = styled.button`
  ${tw`px-4 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all cursor-pointer`}
  
  &:disabled {
    ${tw`opacity-50 cursor-not-allowed`}
  }
`;

export const CancelButton = styled.button`
  ${tw`px-4 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all cursor-pointer`}
  
  &:disabled {
    ${tw`opacity-50 cursor-not-allowed`}
  }
`;

export const ApplyButton = styled.button`
  ${tw`flex items-center gap-2 px-6 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all cursor-pointer border-none shadow-lg`}
  
  &:disabled {
    ${tw`opacity-50 cursor-not-allowed`}
  }
`;

export const LoadingSpinner = styled.div`
  ${tw`w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin`}
`;